import { IGif } from '@giphy/js-types'
import { getGifHeight } from '@giphy/js-util'

export const spotlightWidth = 512
const desktopGap = 12
const carouselHeight = 124

export const getVideoOffset = (gif: IGif) => {
    const gifHeight = getGifHeight(gif, spotlightWidth)
    return gifHeight + desktopGap
}

export const getCarouselOffset = (gif: IGif) => {
    const gifHeight = getGifHeight(gif, spotlightWidth)
    return gifHeight + desktopGap * 2 + carouselHeight
}
